"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCAL_PORT_MAP = exports.LOCAL_JOB = exports.ORGANIC_REPLICA_WEB_SERVICE = exports.ORGANIC_REPLICA_UPDATER_WORKER = exports.ORGANIC_REPLICA_UPDATER_JOB = exports.SERVICES_WEB_SERVICE = exports.RULES_WORKER_SERVICE = exports.RULES_JOB = exports.RULES_WEB_SERVICE = exports.INGRESS_BID_WORKER_SERVICE = exports.INGRESS_WEB_SERVICE = exports.EGRESS_WORKER_SERVICE = exports.EGRESS_JOB = exports.BUDGETS_ALLOCATION_WORKER_SERVICE = exports.BUDGETS_ALLOCATION_JOB = exports.BUDGETS_WEB_SERVICE = exports.PAYMENTS_INVOICE_WORKER_SERVICE = exports.PAYMENTS_INVOICE_JOB = exports.NOTIFICATIONS_WORKER_SERVICE = exports.ACCOUNTS_WEB_SERVICE = exports.ATTRIBUTION_ENDPOINT_WEB_SERVICE = exports.ATTRIBUTION_INGEST_WORKER_SERVICE = exports.ATTRIBUTION_WEB_SERVICE = exports.ERROR_WORKER_SERVICE = exports.HISTORY_WORKER_SERVICE = exports.INTERACTIONS_WEB_SERVICE = exports.APPLE_AUTH_JOB = exports.APPLE_AUTH_WEB_SERVICE = exports.APPLE_CHANNELS_SCHEDULED_CHANGES_JOB = exports.APPLE_CHANNELS_SCHEDULED_CHANGES_WORKER_SERVICE = exports.APPLE_CHANNELS_SYNC_JOB = exports.APPLE_CHANNELS_SYNC_WORKER_SERVICE = exports.APPLE_CHANNELS_WEB_SERVICE = exports.APPLE_REPLICA_UPDATER_JOB = exports.APPLE_REPLICA_UPDATER_WORKER = exports.APPLE_REPLICA_WEB_SERVICE = exports.APPLE_PROXY_WEB_SERVICE = void 0;
exports.APPLE_PROXY_WEB_SERVICE = "apple-proxy-web";
exports.APPLE_REPLICA_WEB_SERVICE = "apple-replica-web";
exports.APPLE_REPLICA_UPDATER_WORKER = "apple-replica-updater-worker";
exports.APPLE_REPLICA_UPDATER_JOB = "apple-replica-updater-job";
exports.APPLE_CHANNELS_WEB_SERVICE = "apple-channels-web";
exports.APPLE_CHANNELS_SYNC_WORKER_SERVICE = "apple-channels-sync-worker";
exports.APPLE_CHANNELS_SYNC_JOB = "apple-channels-sync-job";
exports.APPLE_CHANNELS_SCHEDULED_CHANGES_WORKER_SERVICE = "apple-channels-scheduled-changes-worker";
exports.APPLE_CHANNELS_SCHEDULED_CHANGES_JOB = "apple-channels-scheduled-changes-job";
exports.APPLE_AUTH_WEB_SERVICE = "apple-auth-web";
exports.APPLE_AUTH_JOB = "apple-auth-job";
exports.INTERACTIONS_WEB_SERVICE = "interactions-web";
exports.HISTORY_WORKER_SERVICE = "history-worker";
exports.ERROR_WORKER_SERVICE = "error-worker";
exports.ATTRIBUTION_WEB_SERVICE = "attribution-web";
exports.ATTRIBUTION_INGEST_WORKER_SERVICE = "attribution-ingest-worker";
exports.ATTRIBUTION_ENDPOINT_WEB_SERVICE = "attribution-endpoint-web";
exports.ACCOUNTS_WEB_SERVICE = "accounts-web";
exports.NOTIFICATIONS_WORKER_SERVICE = "notifications-worker";
exports.PAYMENTS_INVOICE_JOB = "payments-invoice-job";
exports.PAYMENTS_INVOICE_WORKER_SERVICE = "payments-invoice-worker";
exports.BUDGETS_WEB_SERVICE = "budgets-web";
exports.BUDGETS_ALLOCATION_JOB = "budgets-allocation-job";
exports.BUDGETS_ALLOCATION_WORKER_SERVICE = "budgets-allocation-worker";
exports.EGRESS_JOB = "egress-job";
exports.EGRESS_WORKER_SERVICE = "egress-worker";
exports.INGRESS_WEB_SERVICE = "ingress-web";
exports.INGRESS_BID_WORKER_SERVICE = "ingress-bid-worker";
exports.RULES_WEB_SERVICE = "rules-web";
exports.RULES_JOB = "rules-job";
exports.RULES_WORKER_SERVICE = "rules-worker";
exports.SERVICES_WEB_SERVICE = "services-web";
exports.ORGANIC_REPLICA_UPDATER_JOB = "organic-replica-updater-job";
exports.ORGANIC_REPLICA_UPDATER_WORKER = "organic-replica-updater-worker";
exports.ORGANIC_REPLICA_WEB_SERVICE = "organic-replica-web";
// A job that should only be run locally (not deployed), and be reused for any purpose
exports.LOCAL_JOB = "local-job";
const LOCAL_BASE_PORT = 8100;
const DEFAULT_LOCAL_PORT_MAPPING = {
    [exports.APPLE_PROXY_WEB_SERVICE]: LOCAL_BASE_PORT + 0,
    [exports.APPLE_REPLICA_UPDATER_WORKER]: LOCAL_BASE_PORT + 1,
    [exports.APPLE_REPLICA_WEB_SERVICE]: LOCAL_BASE_PORT + 2,
    [exports.APPLE_REPLICA_UPDATER_JOB]: LOCAL_BASE_PORT + 3,
    [exports.APPLE_AUTH_WEB_SERVICE]: LOCAL_BASE_PORT + 4,
    [exports.APPLE_AUTH_JOB]: LOCAL_BASE_PORT + 5,
    [exports.INTERACTIONS_WEB_SERVICE]: LOCAL_BASE_PORT + 10,
    [exports.HISTORY_WORKER_SERVICE]: LOCAL_BASE_PORT + 11,
    [exports.ERROR_WORKER_SERVICE]: LOCAL_BASE_PORT + 12,
    [exports.ATTRIBUTION_WEB_SERVICE]: LOCAL_BASE_PORT + 20,
    [exports.ATTRIBUTION_INGEST_WORKER_SERVICE]: LOCAL_BASE_PORT + 21,
    [exports.ATTRIBUTION_ENDPOINT_WEB_SERVICE]: LOCAL_BASE_PORT + 22,
    [exports.ACCOUNTS_WEB_SERVICE]: LOCAL_BASE_PORT + 30,
    [exports.ORGANIC_REPLICA_UPDATER_JOB]: LOCAL_BASE_PORT + 35,
    [exports.ORGANIC_REPLICA_UPDATER_WORKER]: LOCAL_BASE_PORT + 36,
    [exports.ORGANIC_REPLICA_WEB_SERVICE]: LOCAL_BASE_PORT + 37,
    [exports.RULES_WEB_SERVICE]: LOCAL_BASE_PORT + 40,
    [exports.RULES_JOB]: LOCAL_BASE_PORT + 41,
    [exports.RULES_WORKER_SERVICE]: LOCAL_BASE_PORT + 42,
    [exports.SERVICES_WEB_SERVICE]: LOCAL_BASE_PORT + 45,
    [exports.BUDGETS_WEB_SERVICE]: LOCAL_BASE_PORT + 50,
    [exports.BUDGETS_ALLOCATION_JOB]: LOCAL_BASE_PORT + 51,
    [exports.BUDGETS_ALLOCATION_WORKER_SERVICE]: LOCAL_BASE_PORT + 52,
    [exports.NOTIFICATIONS_WORKER_SERVICE]: LOCAL_BASE_PORT + 60,
    [exports.APPLE_CHANNELS_WEB_SERVICE]: LOCAL_BASE_PORT + 70,
    [exports.APPLE_CHANNELS_SYNC_WORKER_SERVICE]: LOCAL_BASE_PORT + 71,
    [exports.APPLE_CHANNELS_SYNC_JOB]: LOCAL_BASE_PORT + 72,
    [exports.APPLE_CHANNELS_SCHEDULED_CHANGES_WORKER_SERVICE]: LOCAL_BASE_PORT + 73,
    [exports.APPLE_CHANNELS_SCHEDULED_CHANGES_JOB]: LOCAL_BASE_PORT + 74,
    [exports.PAYMENTS_INVOICE_JOB]: LOCAL_BASE_PORT + 81,
    [exports.PAYMENTS_INVOICE_WORKER_SERVICE]: LOCAL_BASE_PORT + 82,
    [exports.EGRESS_JOB]: LOCAL_BASE_PORT + 91,
    [exports.EGRESS_WORKER_SERVICE]: LOCAL_BASE_PORT + 92,
    [exports.INGRESS_WEB_SERVICE]: LOCAL_BASE_PORT + 93,
    [exports.INGRESS_BID_WORKER_SERVICE]: LOCAL_BASE_PORT + 94,
    [exports.LOCAL_JOB]: LOCAL_BASE_PORT + 99,
};
/**
 * When running locally (npm run dev) we can't run everything on the same port
 * As such we map each service to a different port.
 */
exports.DEFAULT_LOCAL_PORT_MAP = new Map(Object.entries(DEFAULT_LOCAL_PORT_MAPPING));
